import { sendEvent, type sendEventProps } from '.';

export const EVENTS_ENDPOINT = '/api/events';

/**
 * Sends an event to New Relic from either environment.
 * On the server it calls sendEvent directly. In the browser it posts to the app's
 * events route with sendBeacon, so analytics never queue behind data server actions.
 *
 * @param {sendEventProps} props - The event to send.
 */
export const trackEvent = async (props: sendEventProps) => {
  if (typeof window === 'undefined') return sendEvent(props);
  const body = JSON.stringify(props);
  if (navigator.sendBeacon?.(EVENTS_ENDPOINT, new Blob([body], { type: 'application/json' }))) return;
  fetch(EVENTS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => undefined);
};
